var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"animation":"fadein .35s ease"}},[_vm._t("conteudo"),_vm._v(" "),_vm._t("rodape")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }